import { API } from '@/api';
import { fetcher } from '@/services/fetcher';

import { type LaneItem, laneSchema } from '../../../models';

const pricing = fetcher.extend(() => ({ prefixUrl: `${API.BASE_PRICING}` }));

export const fetchLane = (laneKey: LaneItem['laneKey'], { signal }: { signal?: AbortController['signal'] } = {}) => {
  return pricing
    .get(`lane/${laneKey}`, {
      signal,
    })
    .json(laneSchema);
};
